export const serviceList = [
  { id: "brand",      icon: "◈", title: "Marka Stratejisi & Danışmanlık",   desc: "Ürün konumlandırması, pazar analizi, yıllık hedefler." },
  { id: "ads",        icon: "◉", title: "Dijital Reklam Yönetimi",           desc: "Google, Meta, TikTok, LinkedIn: 4 platformda tam yönetim." },
  { id: "production", icon: "◎", title: "Reklam Çekimi & Prodüksiyon",       desc: "Senaryo, çekim, kurgu. Amerikan disipliniyle." },
  { id: "social",     icon: "⬡", title: "Sosyal Medya Yönetimi",             desc: "İçerik, tasarım, yayın, topluluk ve CRM entegrasyonu." },
  { id: "trendyol",   icon: "◫", title: "Trendyol & E-ticaret Yönetimi",     desc: "Kurulumdan reklama, içerikten rapora." },
  { id: "mail",       icon: "◬", title: "Mail Marketing & Yurt Dışı",        desc: "Global pazarlara açılım, sıfırdan liste oluşturma." },
  { id: "research",   icon: "◭", title: "Pazar Araştırması & Ürün Analizi",  desc: "Veriyle karar ver. Rakip, müşteri, fiyat analizi." },
  { id: "web",        icon: "◪", title: "Web Tasarım & Yazılım",             desc: "Shopify, özel yazılım, kurumsal site, bakım." },
  { id: "seo",        icon: "◯", title: "SEO & GEO: Arama Optimizasyonu",     desc: "Hem Google'da hem yapay zeka aramalarında üst sıralarda çık." },
];

export const serviceDetails = {
  brand: {
    badge: "HİZMET: MARKA STRATEJİSİ",
    heroTitle: "Nerede Durduğunu",
    heroHighlight: "Biz Belirliyoruz.",
    heroSubtitle: "Ürünün piyasaya hazır mı? Müşterin gerçekte kim? Rakibinden farkın ne? Bu soruların cevabı yoksa reklam bütçen boşa akar.",
    problemTitle: "Bu durumları yaşıyor musun?",
    problems: [
      { icon: "", text: "Reklam veriyorsun ama satış gelmiyor. Sorun reklamda değil, konumlandırmada olabilir." },
      { icon: "", text: "Rakiplerin ne yapıyor, sen ne yapıyorsun: aradaki fark net değil. Müşteri neden seni seçsin?" },
      { icon: "", text: "Fiyat belirlemekte zorlanıyorsun. Pazar gerçekte ne kabul ediyor?" },
    ],
    solutionTitle: "Markan için özel strateji, adım adım",
    steps: [
      { title: "Ürün & Hizmet Analizi", desc: "Sunduğun ürün veya hizmetin piyasadaki gerçek konumunu belirliyoruz. Güçlü ve zayıf yönleri net koyuyoruz." },
      { title: "Rakip & Sektör Haritası", desc: "Sektördeki oyuncuları, fiyat aralıklarını ve boşlukları analiz ediyoruz. Fırsatların nerede olduğunu görüyoruz." },
      { title: "Hedef Kitle Tanımı", desc: "Gerçek müşterinin kim olduğunu veriye dayalı olarak çıkarıyoruz. Demografik değil, davranışsal profil." },
      { title: "Yıllık Hedef & Yol Haritası", desc: "Somut büyüme hedefleri koyuyor, aylık aksiyon planı oluşturuyoruz. Her adım ölçülebilir." },
      { title: "Tüm İhtiyaçların Çıkarılması", desc: "Markanın eksiklerini, fırsatlarını ve önceliklerini birlikte belirliyoruz. Sıradaki adım netleşiyor." },
      { title: "Konumlandırma & Mesaj Stratejisi", desc: "Markanın sesi, tonu ve söylemi belirleniyor. Müşterine nasıl konuşacağını tanımlıyoruz." },
    ],
    note: "Her marka farklıdır. Sabit paketler sunmuyoruz: firmanın ihtiyacı ne gerektiriyorsa o kadar derine iniyoruz.",
    outcomes: [
"Net ürün konumlandırması ve pazar yeri tanımı",
"Derinlemesine rakip analizi raporu",
"Gerçek hedef kitle profili",
"Yıllık büyüme hedefleri ve öncelik listesi",
"Marka ses tonu ve mesaj stratejisi",
"Hangi kanalların işe yarayacağına dair net yönlendirme",
    ],
  },

  ads: {
    badge: "HİZMET: DİJİTAL REKLAM YÖNETİMİ",
    heroTitle: "Her Kuruşun",
    heroHighlight: "Çalışsın.",
    heroSubtitle: "Google, Meta, TikTok ve LinkedIn'de bütçeni en optimum şekilde yönetiyoruz. Haftalık, aylık ve yıllık raporlarla tam şeffaflık.",
    problemTitle: "Tanıdık geliyor mu?",
    problems: [
      { icon: "", text: "Reklam ajansın bütçeni harcıyor ama ne döndüğünü net olarak açıklayamıyor." },
      { icon: "", text: "Hangi reklamın işe yaradığını bilmiyorsun. Raporlar geliyor ama anlaşılmıyor." },
      { icon: "", text: "Yanlış kitleye ulaşıyorsun. Tıklama var, satış yok." },
    ],
    solutionTitle: "4 platformda, tek elden yönetim",
    steps: [
      { title: "Bütçe Optimizasyonu", desc: "Müşterimizin çıkabileceği maksimum bütçeyi değil, en yüksek verimi sağlayacak optimum bütçe aralığını belirliyoruz." },
      { title: "Platform Stratejisi", desc: "Google Ads, Meta (Facebook & Instagram), TikTok ve LinkedIn: her platform için ayrı strateji ve kreatif yaklaşım." },
      { title: "Kreatif & Senaryo", desc: "Reklamın görseli, metni ve senaryosu bizden. Sadece bütçe yönetimi değil, uçtan uca kampanya üretimi." },
      { title: "Hedefleme & Segmentasyon", desc: "Doğru kişiye, doğru zamanda, doğru mesajla ulaşmak için detaylı kitle segmentasyonu yapıyoruz." },
      { title: "Haftalık Optimizasyon", desc: "Kampanyaları sürekli izliyor, işe yaramayanı durduruyor, işe yarayanı ölçeklendiriyoruz." },
      { title: "Şeffaf Raporlama", desc: "Haftalık, aylık ve yıllık raporlar. Ne harcandı, ne kazanıldı, bir sonraki adım ne: net ve anlaşılır." },
    ],
    note: "Reklam bütçeni belirlemeden önce sektörünü ve rakiplerini analiz ediyoruz. Körü körüne değil, veriyle ilerliyoruz.",
    outcomes: [
"4 platformda entegre kampanya yönetimi",
"Optimum bütçe planı ve dağılımı",
"Haftalık performans raporları",
"Aylık ve yıllık büyüme analizleri",
"Platform bazlı kreatif ve senaryo üretimi",
"Sürekli A/B testi ve optimizasyon",
    ],
  },

  production: {
    badge: "HİZMET: REKLAM ÇEKİMİ & PRODÜKSIYON",
    heroTitle: "Fikir Kağıtta,",
    heroHighlight: "Ekranda Hayat Buluyor.",
    heroSubtitle: "Senaryo yazımından çekime, kurgudan yayına: prodüksiyonun her aşaması bizde. Amerikan senaryo disipliniyle, Türkiye'de üretiyoruz.",
    problemTitle: "Bu sorunları yaşıyor musun?",
    problems: [
      { icon: "", text: "İçerik üretmek istiyorsun ama ne çekeceğini, nasıl anlatacağını bilmiyorsun." },
      { icon: "", text: "Senaryo için ayrı, çekim için ayrı, kurgu için ayrı yerlerle uğraşmaktan yoruldun." },
      { icon: "", text: "Üretilen içerikler markanı tam yansıtmıyor, sıradan ve etkisiz görünüyor." },
    ],
    solutionTitle: "Fikirden yayına, her şey burada",
    steps: [
      { title: "Amerikan Tarzı Senaryo Yazımı", desc: "Her çekim için profesyonel senaryo yazıyoruz. Müşteri kendi çekmek isterse senaryoyu hazır teslim ediyoruz." },
      { title: "Çekim Planlaması", desc: "Stüdyo, lokasyon, drone: ihtiyaca göre planlama yapıyoruz. Çekim günü her şey hazır." },
      { title: "Stüdyo & Lokasyon Çekimleri", desc: "Ürün çekimlerinden marka filmlerine, sosyal medya içeriklerinden kurumsal tanıtımlara kadar her türlü çekim." },
      { title: "Drone & Özel Çekimler", desc: "Hava çekimleri, hareketli sahneler, teknik gerektiren prodüksiyonlar: gerekli ekipmanla çalışıyoruz." },
      { title: "Kurgu & Post Production", desc: "Renk düzeltme, ses miksaj, motion grafik, altyazı: ekrana hazır hâle getiriyoruz." },
      { title: "Platform Uyumlu Çıktılar", desc: "Instagram reels, TikTok, YouTube, reklam banner'ları: her format ayrı ayrı teslim edilir." },
    ],
    note: "Bizimle çalışan her müşteri için senaryo yazıyoruz. İyi bir çekim, iyi bir senaryodan başlar.",
    outcomes: [
"Profesyonel Amerikan tarzı senaryo",
"Stüdyo veya lokasyon çekimi",
"Drone görüntüleri (gerekirse)",
"Kurgu ve post-production",
"Platform uyumlu tüm formatlar",
"Yayına hazır içerik paketi",
    ],
  },

  social: {
    badge: "HİZMET: SOSYAL MEDYA YÖNETİMİ",
    heroTitle: "Hesapların Sadece",
    heroHighlight: "Var Olmakla Kalmıyor.",
    heroSubtitle: "İçerik takvimi, tasarım, yayınlama, topluluk yönetimi ve CRM entegrasyonu. Sosyal medyan bir satış kanalına dönüşüyor.",
    problemTitle: "Sosyal medyada kaybolmuş hissediyor musun?",
    problems: [
      { icon: "", text: "Düzenli içerik üretemiyorsun. Hesaplar bazen aktif, bazen aylarca sessiz." },
      { icon: "", text: "Yorumlar ve mesajlar yanıtsız kalıyor. Potansiyel müşteriler kaçıyor." },
      { icon: "", text: "Takipçi var ama satışa dönmüyor. Etkileşim düşük, erişim azalıyor." },
    ],
    solutionTitle: "Sosyal medyanı uçtan uca yönetiyoruz",
    steps: [
      { title: "İçerik Takvimi", desc: "Aylık içerik planı oluşturuyoruz. Ne zaman ne paylaşılacak, hangi format kullanılacak: her şey önceden planlanıyor." },
      { title: "Tasarım & Prodüksiyon", desc: "Markana uygun görsel kimlikle içerikler tasarlıyoruz. Reels, story, carousel, statik post: hepsi." },
      { title: "Zamanlanmış Yayınlama", desc: "En yüksek etkileşim saatlerinde, doğru platformda yayınlıyoruz. Manüel değil, stratejik." },
      { title: "Topluluk Yönetimi", desc: "Yorumları ve mesajları takip ediyoruz. İstersen müşteri adına yanıt veriyoruz, marka sesini koruyarak." },
      { title: "CRM Entegrasyonu", desc: "Potansiyel müşterileri tespit edip CRM üzerinden sana bildiriyoruz. Sosyal medya bir lead kaynağına dönüşüyor." },
      { title: "Performans Analizi", desc: "Hangi içerik işe yaradı, hangisi yaramadı? Veriye bakıp her ay stratejiyi güncelliyoruz." },
    ],
    note: "Sosyal medya yönetimi sadece içerik atmak değil. Doğru kişiye ulaşmak, potansiyel müşteri yakalamak ve markayı büyütmek demek.",
    outcomes: [
"Aylık içerik takvimi ve planlaması",
"Marka kimliğine uygun tasarımlar",
"Tüm platformlarda zamanlanmış yayın",
"Yorum ve mesaj yönetimi (isteğe bağlı)",
"CRM üzerinden potansiyel müşteri bildirimi",
"Aylık performans raporu",
    ],
  },

  trendyol: {
    badge: "HİZMET: TRENDYOL & E-TİCARET YÖNETİMİ",
    heroTitle: "Trendyol'da Satmak",
    heroHighlight: "Başka Bir İş.",
    heroSubtitle: "Mağaza kurulumundan SEO'ya, ürün içeriklerinden reklam yönetimine kadar Trendyol operasyonunun tamamını üstleniyoruz.",
    problemTitle: "Trendyol'da bu sorunları yaşıyor musun?",
    problems: [
      { icon: "", text: "Mağazan var ama arama sonuçlarında görünmüyor. Ürünlerin kaybolup gidiyor." },
      { icon: "", text: "Ürün açıklamaların zayıf, görseller yetersiz. Rakipler öne geçiyor." },
      { icon: "", text: "Trendyol reklamları veriyorsun ama geri dönüşü ölçemiyorsun." },
    ],
    solutionTitle: "Trendyol'da uçtan uca yönetim",
    steps: [
      { title: "Mağaza Kurulumu", desc: "Sıfırdan profesyonel mağaza kuruyoruz. Marka kimliğine uygun görsel düzenleme ve kategori yapılandırması." },
      { title: "Trendyol SEO'ya Uygun İçerik", desc: "Ürün başlıkları ve açıklamaları Trendyol arama algoritmasına göre yazıyoruz. Doğru anahtar kelimeler, yüksek sıralama." },
      { title: "Ürün Fotoğrafı & Görseller", desc: "İstersen ürün fotoğraf çekimi de yapıyoruz. Trendyol standartlarına uygun, satışı artıran görseller." },
      { title: "Kampanya & Fiyat Yönetimi", desc: "Trendyol kampanyalarına katılım stratejisi, fiyat optimizasyonu ve stok yönetimi konusunda yönlendiriyoruz." },
      { title: "Trendyol Reklam Yönetimi", desc: "Sponsored ürün reklamlarını yönetiyoruz. Bütçe optimizasyonu ve performans takibi dahil." },
      { title: "Performans Raporlama", desc: "Satış verileri, reklam performansı, rakip analizi: düzenli raporlarla her şey şeffaf." },
    ],
    note: "Trendyol'un SEO sistemi Google'dan farklı çalışır. Bu ayrımı bilerek, platforma özel stratejilerle çalışıyoruz.",
    outcomes: [
"Profesyonel Trendyol mağaza kurulumu",
"SEO uyumlu ürün içerikleri",
"Satış artıran ürün görselleri",
"Trendyol reklam yönetimi",
"Kampanya ve fiyat stratejisi",
"Düzenli satış ve performans raporları",
    ],
  },

  mail: {
    badge: "HİZMET: MAİL MARKETİNG & YURT DIŞI",
    heroTitle: "Sınırları Aş,",
    heroHighlight: "Dünyaya Açıl.",
    heroSubtitle: "Avrupa, Amerika, Orta Doğu ve Türki cumhuriyetlerde gerçek bağlantılar kuruyoruz. Mail listesini sıfırdan oluşturuyoruz, içerikleri biz yazıyoruz.",
    problemTitle: "Yurt dışına açılmak istiyor ama nereden başlayacağını bilemiyor musun?",
    problems: [
      { icon: "", text: "Yurt dışı pazarlara açılmak istiyorsun ama nasıl ulaşacağını bilmiyorsun." },
      { icon: "", text: "Mail marketing denedin ama yanıt gelmedi. Liste kalitesiz, içerikler yanlış." },
      { icon: "", text: "Yabancı iş ortakları bulmak istiyorsun ama doğru kanalları bulamıyorsun." },
    ],
    solutionTitle: "Global pazarlara stratejik açılım",
    steps: [
      { title: "Pazar Seçimi & Analizi", desc: "Avrupa, Amerika, Orta Doğu ve Türki cumhuriyetler: hangi pazar ürününe uygun? Veriyle belirliyoruz." },
      { title: "Mail Listesi Oluşturma", desc: "Sıfırdan, hedefe özel mail listesi oluşturuyoruz. Satın alınan listeler değil, gerçek potansiyel müşteriler." },
      { title: "İçerik & Kampanya Yazımı", desc: "Atılacak maillerin tamamını yazıyoruz. Kültürel farklılıklara uygun, dönüşüm odaklı içerikler." },
      { title: "Fuar & Etkinlik Desteği", desc: "Yurt dışı fuarlarda müşteri bulma, bağlantı kurma ve takip sürecini yönetiyoruz." },
      { title: "LinkedIn & Outreach", desc: "B2B pazarlarda LinkedIn üzerinden hedefli outreach kampanyaları yürütüyoruz." },
      { title: "Türki Cumhuriyetler Ağı", desc: "Bu pazarlarda güçlü yerel bağlantılarımız var. Doğru kapıları açıyoruz." },
    ],
    note: "Yurt dışı açılım uzun soluklu bir süreçtir. Kısa vadeli beklentilerle değil, gerçek büyüme hedefiyle çalışıyoruz.",
    outcomes: [
"Pazar analizi ve ülke seçim raporu",
"Hedeflenmiş yurt dışı mail listesi",
"Kültüre uygun mail içerikleri",
"Fuar ve etkinlik müşteri takibi",
"LinkedIn outreach kampanyaları",
"Türki cumhuriyetlerde yerel bağlantılar",
    ],
  },

  research: {
    badge: "HİZMET: PAZAR ARAŞTIRMASI & ÜRÜN ANALİZİ",
    heroTitle: "Veri Olmadan",
    heroHighlight: "Karar Verilmez.",
    heroSubtitle: "Ürünün piyasaya hazır mı? Müşteri ne istiyor? Fiyatlandırma doğru mu? Bu soruları veriyle yanıtlıyor, aksiyon öneriyoruz.",
    problemTitle: "Bu belirsizlikleri yaşıyor musun?",
    problems: [
      { icon: "", text: "Ürününün gerçekten pazarda yeri var mı bilmiyorsun. Sezgiyle ilerlemekten korkuyorsun." },
      { icon: "", text: "Fiyatının doğru olup olmadığından emin değilsin. Ucuz mu, pahalı mı, orta mı?" },
      { icon: "", text: "Rakiplerin ne yapıyor, hangi stratejileri izliyor: bunu takip edemiyorsun." },
    ],
    solutionTitle: "Kararlarını veriye dayandır",
    steps: [
      { title: "Ürün Pazar Uyumu Analizi", desc: "Ürününün mevcut pazardaki talep, boşluk ve rekabet durumunu analiz ediyoruz." },
      { title: "Müşteri Araştırması", desc: "Gerçek hedef kitleyi belirliyor, satın alma davranışlarını ve motivasyonlarını ortaya çıkarıyoruz." },
      { title: "Rakip Analizi", desc: "Rakiplerin güçlü/zayıf yönleri, fiyat stratejileri, içerik taktikleri: detaylı karşılaştırma." },
      { title: "Fiyat Stratejisi", desc: "Pazar verilerine göre optimum fiyat aralığını belirliyoruz. Ne çok ucuz, ne gereksiz pahalı." },
      { title: "Sektör Trendleri", desc: "Sektörde nereye gidildiğini takip ediyor, fırsatları erkenden görmeni sağlıyoruz." },
      { title: "Aksiyon Raporu", desc: "Sadece analiz değil, ne yapılması gerektiğini de söylüyoruz. Rapor bitince ne yapacağını biliyorsun." },
    ],
    note: "Bu hizmeti ayrıca da sunuyoruz: ama tüm hizmetlerimizin temelinde bu araştırma yatıyor. Veri olmadan hiçbir şey başlatmıyoruz.",
    outcomes: [
"Ürün-pazar uyumu analiz raporu",
"Hedef kitle profili ve davranış analizi",
"Derinlemesine rakip analizi",
"Optimum fiyatlandırma önerisi",
"Sektör trend raporu",
"Net aksiyon planı ve öncelik listesi",
    ],
  },

  web: {
    badge: "HİZMET: WEB TASARIM & YAZILIM",
    heroTitle: "Dijital Varlığın",
    heroHighlight: "Markanı Konuşsun.",
    heroSubtitle: "Kurumsal sitelerden e-ticaret platformlarına, landing page'den özel yazılımlara. Tasarım ve teknik ihtiyacın tek çatıda.",
    problemTitle: "Web siten seni yansıtmıyor mu?",
    problems: [
      { icon: "", text: "Web siten eski ve güncel değil. Ziyaretçi geliyor ama güven vermiyor, çıkıp gidiyor." },
      { icon: "", text: "E-ticaret sitende teknik sorunlar var. Ödeme problemi, yavaş yükleme, mobil uyumsuzluk." },
      { icon: "", text: "Site yaptırdın ama sonra sahipsiz kaldı. Güncelleme, bakım, destek yok." },
    ],
    solutionTitle: "Tasarımdan koda, teslimden bakıma",
    steps: [
      { title: "Kurumsal Web Sitesi", desc: "Markanı doğru yansıtan, güven veren, dönüşüm odaklı kurumsal siteler tasarlıyoruz." },
      { title: "E-ticaret Platformu", desc: "Shopify ve özel yazılım çözümleriyle satış yapan, ölçeklenen e-ticaret siteleri kuruyoruz." },
      { title: "Landing Page Tasarımı", desc: "Tek hedef: dönüşüm. Kampanya sayfaları, ürün tanıtım sayfaları, lead generation sayfaları." },
      { title: "Özel Yazılım Geliştirme", desc: "Standart çözümlerin yetmediği yerde özel yazılım geliştiriyoruz. İhtiyacına göre." },
      { title: "Tasarım & UX", desc: "Sadece güzel değil, kullanılabilir. Kullanıcı deneyimini merkeze alarak tasarlıyoruz." },
      { title: "Bakım & Destek", desc: "Site teslim sonrası da yanındayız. Güncelleme, hata giderme ve teknik destek sağlıyoruz." },
    ],
    note: "Hosting ve domain için kurumsal alanlarda uzmanlaşmış firmalara yönlendiriyoruz: sana en doğru çözümü öneriyoruz.",
    outcomes: [
"Kurumsal web sitesi veya e-ticaret platformu",
"Shopify veya özel yazılım çözümü",
"Mobil uyumlu, hızlı yüklenen tasarım",
"Dönüşüm odaklı landing page'ler",
"Süregelen bakım ve teknik destek",
"Hosting ve domain için doğru yönlendirme",
    ],
  },

  seo: {
    badge: "HİZMET: SEO & GEO OPTİMİZASYONU",
    heroTitle: "Google'da ve Yapay Zekada",
    heroHighlight: "Görünür Ol.",
    heroSubtitle: "Klasik SEO artık yetmiyor. ChatGPT, Gemini, Perplexity gibi yapay zekalar artık markanı öneriyor: ya da önermiyor. Biz hem Google'da hem AI aramalarında seni üst sıralara taşıyoruz.",
    problemTitle: "Dijitalde görünmez misin?",
    problems: [
      { icon: "", text: "Google'da arayanlar seni bulamıyor. Rakiplerin üst sıralarda, sen sayfalarda kayboluyorsun." },
      { icon: "", text: "Yapay zeka araçları (ChatGPT, Gemini, Perplexity) rakiplerini öneriyor ama senden hiç bahsetmiyor." },
      { icon: "", text: "Sitende teknik SEO sorunları var ve içeriklerin ne arama motorları ne de AI tarafından anlaşılabiliyor." },
    ],
    solutionTitle: "SEO + GEO: Çift kanatlı strateji",
    steps: [
      { title: "Teknik SEO Denetimi", desc: "Site hızı, yapısal hatalar, indexleme sorunları, mobil uyumluluk: teknik temeli sağlıyoruz." },
      { title: "GEO: AI Arama Optimizasyonu", desc: "Schema.org yapılandırılmış veri, robots.txt AI bot izinleri, doğal dil optimizasyonu. ChatGPT, Gemini ve Perplexity gibi yapay zekaların markanı tanımasını ve önermesini sağlıyoruz." },
      { title: "Anahtar Kelime Stratejisi", desc: "Sektörüne özel anahtar kelime araştırması yapıyor, hem Google hem AI sorguları için hangi terimlerde görünmen gerektiğini belirliyoruz." },
      { title: "Ürün & Kategori Optimizasyonu", desc: "E-ticaret sitelerinde ürün açıklamaları ve kategori sayfaları hem SEO hem GEO'ya uygun yazılıyor." },
      { title: "Düzenli Blog İçerikleri", desc: "Sektör fark etmeksizin düzenli, kaliteli, SEO ve GEO uyumlu blog yazıları üretiyoruz. Yapay zekaların kaynak olarak referans gösterebileceği içerikler." },
      { title: "Link Building & Otorite", desc: "Güvenilir kaynaklardan backlink edinimi ile hem Google otoritesi hem AI güvenilirlik skorunu artırıyoruz." },
    ],
    note: "GEO (Generative Engine Optimization), yapay zeka arama motorlarında markanın görünür olmasını sağlayan yeni nesil optimizasyon stratejisidir. Whayns Dijital olarak SEO ve GEO'yu birlikte yürütüyoruz.",
    outcomes: [
"Teknik SEO denetimi ve düzeltmeleri",
"GEO: Yapay zeka arama optimizasyonu (ChatGPT, Gemini, Perplexity)",
"Schema.org yapılandırılmış veri entegrasyonu",
"Kapsamlı anahtar kelime stratejisi",
"SEO & GEO uyumlu ürün ve kategori içerikleri",
"Düzenli blog yazıları (AI kaynak gösterebilir kalitede)",
"Link building ve site otoritesi artışı",
"Aylık organik trafik, sıralama ve AI görünürlük raporu",
    ],
  },
};